import { type Components, type Theme } from "@mui/material";

export const MuiIconButton: Components<Theme>["MuiIconButton"] = {
  defaultProps: {
    size: "small",
  },
};
